import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../pages/login/Login";
import Landing from "../pages/landing/Landing";
import Signup from "../pages/signup/Signup";
import Verification from "../pages/verify/Verification";
import Setpassword from "../pages/setpassword/Setpassword";
import Forgotpassword from "../pages/forgotpassword/Forgotpassword";
import Leftsection from "../components/common/leftsection/Leftsection";
import MarketPlaceTab from "../pages/marketplace/MarketPlaceTab";
import MarketplaceDetailsPage from '../pages/marketplace/MarketplaceDetailsPage';

const Prelogin = () => {
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            
            {/* Authentication routes with left section layout */}
            <Route element={<Leftsection />}>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/verify" element={<Verification />} />
                <Route path="/setpassword" element={<Setpassword />} />
                <Route path="/forgotpassword" element={<Forgotpassword />} />
            </Route>
            
            {/* ADDED: Marketplace routes for non-logged-in users */}
            <Route path="/marketplace" element={<MarketPlaceTab />} />
            <Route path="/marketplace/:id" element={<MarketplaceDetailsPage />} />
            <Route path="/marketplace/:id/:slug" element={<MarketplaceDetailsPage />} />
            
            {/* Catch-all route */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default Prelogin;